import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Crown, User, Heart, Lightbulb } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

export const PaywallModal = ({ open, onOpenChange, feature }) => {
  const navigate = useNavigate();

  const featureInfo = {
    profiles: {
      icon: User,
      title: 'Perfiles Múltiples',
      description: 'Gestiona alérgenos para toda tu familia',
      price: '0,99',
      benefits: [
        'Perfiles ilimitados',
        'Alérgenos personalizados por persona',
        'Favoritos separados por perfil'
      ]
    },
    favorites: {
      icon: Heart,
      title: 'Favoritos',
      description: 'Guarda tus productos seguros',
      price: '0,99',
      benefits: [
        'Productos favoritos ilimitados',
        'Acceso rápido a productos seguros',
        'Sincronización automática'
      ]
    },
    suggestions: {
      icon: Lightbulb,
      title: 'Sugerencias Múltiples',
      description: 'Más alternativas seguras',
      price: '0,99',
      benefits: [
        '5 sugerencias por producto',
        'Alternativas verificadas',
        'Categorías amplias'
      ]
    }
  };

  const info = featureInfo[feature] || featureInfo.profiles;
  const Icon = info.icon;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Icon className="w-5 h-5 text-[#8FBC8F]" />
            {info.title}
          </DialogTitle>
          <DialogDescription>{info.description}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <Card className="p-4 bg-green-50 border-green-200">
            <div className="text-center">
              <p className="text-3xl font-bold text-[#8FBC8F]">€{info.price}</p>
              <p className="text-sm text-gray-600">por mes</p>
            </div>
          </Card>

          <div className="space-y-2">
            <p className="font-semibold text-sm">Incluye:</p>
            {info.benefits.map((benefit, idx) => (
              <div key={idx} className="flex items-center gap-2 text-sm">
                <div className="w-1.5 h-1.5 rounded-full bg-[#8FBC8F]" />
                {benefit}
              </div>
            ))}
          </div>

          <div className="space-y-2">
            <Button 
              className="w-full bg-[#8FBC8F] hover:bg-[#7aad7a]" 
              onClick={() => {
                navigate('/pricing');
                onOpenChange(false);
              }}
            >
              Desbloquear {info.title}
            </Button>
            
            <Button 
              variant="outline" 
              className="w-full"
              onClick={() => {
                navigate('/pricing');
                onOpenChange(false);
              }}
            >
              <Crown className="w-4 h-4 mr-2 text-yellow-500" />
              Ver Plan Premium (€1,99/mes)
            </Button>
          </div>

          <p className="text-xs text-center text-gray-500">
            Cancela cuando quieras. Sin compromiso.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};